import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FeedbackService } from 'src/app/service/feedback/feedback.service';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.css']
})
export class FeedbackComponent implements OnInit {
  @Input() feedbackTripObj:any;
  @Output() onCloseModal = new EventEmitter<any>()
  comment:any;
  hoveredRating = 0;
  rating:any = 1;
  feedBackId:any;
  
  constructor(private feedbackService : FeedbackService) { }

  ngOnInit() {
    this.getFeedbackById(this.feedbackTripObj._id);
  }

  onClose() {
    this.onCloseModal.emit()
  }

  onSubmit() {
    const payload = {
      assign: this.feedbackTripObj._id,
      driver: this.feedbackTripObj.driver._id,
      comment: this.comment,
      rating: this.rating
    };
  
    if (this.feedBackId) { 
      this.feedbackService.updateFeedback(payload).subscribe((res) => {
        if (res) {
          this.onClose();
        }
      });
    } else {
      this.feedbackService.saveFeedback(payload).subscribe((res) => {
        if (res) {
          this.onClose();
        }
      });
    }
  }
  


  getFeedbackById(assignId){
    this.feedbackService.getFeedbackById(assignId).subscribe((data)=>{
    if(data){
      this.feedBackId = data._id,
      this.comment = data.comment
      this.rating = data.rating
    }
    })
  }

}
